export const SETTING_RESOURCE_COLUMN = 'SETTING_RESOURCE_COLUMN';
export const SETTING_RESOURCE_INDEX = 'SETTING_RESOURCE_INDEX';
export const SETTING_RESOURCE_LOADING_INDEX = 'SETTING_RESOURCE_LOADING_INDEX';
export const SETTING_RESOURCE_LOADING_SHOW = 'SETTING_RESOURCE_LOADING_SHOW';
export const SETTING_RESOURCE_OPTION = 'SETTING_RESOURCE_OPTION';
export const SETTING_RESOURCE_RESET = 'SETTING_RESOURCE_RESET';
export const SETTING_RESOURCE_SEARCH = 'SETTING_RESOURCE_SEARCH';
export const SETTING_RESOURCE_SHOW = 'SETTING_RESOURCE_SHOW';
export const SETTING_RESOURCE_GROUP = 'SETTING_RESOURCE_GROUP';
